import { createSelector } from "reselect";

import { IStore } from "@app/redux/reducers";

const getServiceLocationInfoFunction = (store: IStore) => store.serviceLocation;

export const getServiceLocationInfo = createSelector(
  getServiceLocationInfoFunction,
  f => f,
);

const getServiceLocationLoadingStateFn = (store: IStore) =>
  store.serviceLocation.get("loadingState");

export const getServiceLocationLoadingState = createSelector(
  getServiceLocationLoadingStateFn,
  f => f,
);

const getIsServiceLocationReadyFn = (store: IStore): boolean =>
  !!store.serviceLocation.get("zip") && !!store.serviceLocation.get("city");

export const getIsServiceLocationReady = createSelector(
  getIsServiceLocationReadyFn,
  f => f,
);
